'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeTitleClickEvent = composeTitleClickEvent;
exports.composeAuthorClickEvent = composeAuthorClickEvent;
exports.composeImageClickEvent = composeImageClickEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENTS = _constantsAnalytics2.default.EVENTS,
    CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    ACTIONS = _constantsAnalytics2.default.ACTIONS,
    LABELS = _constantsAnalytics2.default.LABELS,
    CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;
var CONTENT_TYPES = CUSTOM_DIMENSIONS.CONTENT_TYPES;
function composeTitleClickEvent(_ref) {
  var containerName = _ref.containerName,
      reciprocalRank = _ref.reciprocalRank;

  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(EVENTS.BIB_TITLE_CLICK, {
    gtmCategory: CATEGORIES.BIB_COMPONENT,
    gtmAction: ACTIONS.CLICK_TITLE,
    gtmLabel: LABELS.BIB_TITLE,
    gtmValue: 1,
    gtmContainerName: containerName,
    gtmContentType: CONTENT_TYPES.BIB,
    reciprocalRank: reciprocalRank
  })]);
}

function composeAuthorClickEvent(_ref2) {
  var containerName = _ref2.containerName,
      reciprocalRank = _ref2.reciprocalRank;

  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(EVENTS.BIB_AUTHOR_CLICK, {
    gtmCategory: CATEGORIES.BIB_COMPONENT,
    gtmAction: ACTIONS.CLICK_LINK,
    gtmLabel: LABELS.BIB_AUTHOR,
    gtmValue: 1,
    gtmContainerName: containerName,
    gtmContentType: CONTENT_TYPES.BIB,
    reciprocalRank: reciprocalRank
  })]);
}

function composeImageClickEvent(_ref3) {
  var containerName = _ref3.containerName,
      reciprocalRank = _ref3.reciprocalRank;

  return (0, _compose.composeAnalytics)([(0, _compose.composeEvent)(EVENTS.BIB_IMAGE_CLICK, {
    gtmCategory: CATEGORIES.BIB_COMPONENT,
    gtmAction: ACTIONS.CLICK_IMAGE,
    gtmLabel: LABELS.BIB_IMAGE,
    gtmValue: 1,
    gtmContainerName: containerName,
    gtmContentType: CONTENT_TYPES.BIB,
    reciprocalRank: reciprocalRank
  })]);
}

exports.default = {
  composeTitleClickEvent: composeTitleClickEvent,
  composeAuthorClickEvent: composeAuthorClickEvent,
  composeImageClickEvent: composeImageClickEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/bibEventComposer.js
// module id = 574
// module chunks = 0 2 4 5 6 8 9 10 11